<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-10-28 10:31:17
 * @LastEditors: mobai
 * @LastEditTime: 2022-09-08 09:25:27
-->
<template>
  <div class="container">
    <div class="topContainer">
      <section class="leftContent">
        <section class="header">
          <div class="title">{{ type === 'add' ? '新增' : '编辑' }}商品</div>
          <div class="information">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="135px"
            >
              <el-form-item label="商品名称：" prop="goodsName">
                <el-input
                  v-model="ruleForm.goodsName"
                  maxlength="50"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item label="商品类型：" prop="goodsType">
                <el-cascader
                  v-if="disabled"
                  v-model="generalServiceType"
                  :options="generalServiceTypeOptions"
                  :props="{
                    expandTrigger: 'hover',
                    value: 'id',
                    label: 'name',
                    children: 'child'
                  }"
                  @change="changeGeneralService"
                ></el-cascader>
                <el-select
                  v-else
                  v-model="ruleForm.goodsType"
                  placeholder="请选择商品类型"
                >
                  <el-option
                    :label="item.name"
                    :value="item.id"
                    v-for="(item, index) in serviceTypeOptions"
                    :key="index"
                  ></el-option>
                </el-select>
                <div style="font-size: 12px; color: rgba(0, 0, 0, 0.6)">
                  只能发布与当前机构服务类型相关商品
                </div>
              </el-form-item>
              <el-form-item label="价格设置：" prop="priceType">
                <el-radio-group v-model="ruleForm.priceType">
                  <el-radio :label="1">面议</el-radio>
                  <el-radio :label="2">定价</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="ruleForm.priceType == 2" prop="price">
                <div class="PriceBox">
                  <el-input
                    v-model="ruleForm.price"
                    placeholder="请输入数字"
                  ></el-input>
                  <span class="unit">元</span>
                </div>
              </el-form-item>
              <el-form-item label="是否可用服务券：" prop="useCoupon">
                <el-radio-group
                  v-model="ruleForm.useCoupon"
                  :disabled="disabled"
                  @change="changeCoupon"
                >
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
                <div
                  v-if="disabled"
                  style="font-size: 12px; color: rgba(0, 0, 0, 0.6)"
                >
                  您当前为普通机构，无法发布服务券商品
                </div>
              </el-form-item>
              <el-form-item label="主图：" prop="mainImgUrl" ref="imageId">
                <el-upload
                  accept=".bmp, .jpg, .png, .tiff, .jpeg"
                  :class="{ hide: hideUpload }"
                  :action="uploadFile"
                  list-type="picture-card"
                  :headers="uploadHeader"
                  :before-upload="beforePictureUpload"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  :on-success="docSuccess"
                  :limit="1"
                  :file-list="fileList"
                  :on-change="handleChangeImg"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt="" />
                </el-dialog>
                <div class="el-upload__tip">
                  支持图片类型：bmp，jpg，png，tiff，最大不超过5M；建议上传大小为690*240像素的图片
                </div>
              </el-form-item>

              <el-form-item label="收费模式：" prop="chargeMode">
                <el-input
                  :disabled="true"
                  v-model="ruleForm.chargeMode"
                  maxlength="50"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item label="服务地区：">
                <el-input
                  v-model="ruleForm.serveArea"
                  maxlength="50"
                  disabled
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item label="服务对象：">
                <el-checkbox-group v-model="ruleForm.serveTarget">
                  <el-checkbox
                    :label="item.id"
                    v-for="(item, index) in serveTargetList"
                    :key="index"
                    >{{ item.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="服务方式：">
                <el-checkbox-group v-model="ruleForm.serveWay">
                  <el-checkbox
                    :label="item.id"
                    v-for="(item, index) in serveWayList"
                    :key="index"
                    >{{ item.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="商品简介：" prop="desc" ref="desc">
                <div id="editor"></div>
              </el-form-item>
              <el-form-item label="附件：" class="author">
                <el-upload
                  ref="uploader"
                  :action="uploadFile"
                  :before-upload="beforeAvatarUpload"
                  :on-remove="handleRemove1"
                  multiple
                  accept=".ppt, .pptx, .doc, .docx, .pdf, .xls, .xlsx"
                  :headers="uploadHeader"
                  :limit="5"
                  :file-list="fileList1"
                  :on-success="docSuccess1"
                  :on-exceed="handleExceed"
                >
                  <el-button icon="el-icon-upload2">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    支持扩展名：.ppt .pptx .doc .docx .pdf .xls
                    .xlsx,文件大小不超过5M，最多上传5个
                  </div>
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
        </section>
      </section>

      <auditRecord
        v-if="type === 'edit'"
        :goodsRecord="goodsRecordList"
      ></auditRecord>
    </div>
    <el-dialog :visible.sync="showImg" width="30%" class="showImg">
      <img width="100%" :src="exhibitImg" alt="" />
    </el-dialog>
    <div class="bottomBox">
      <el-button @click="handleCancel()">取消</el-button>
      <el-button type="primary" @click="type === 'add' ? save() : editSave()"
        >保存</el-button
      >
    </div>
  </div>
</template>

<script>
import {
  allDictInfo,
  addOrEditProduct,
  entProductDetail,
  uploadFile,
  getGoodsType,
  getServiceTypeList,
  getUserArea
} from '@api/yardIntermediary/commodityManagement-ent'
import auditRecord from './components/auditRecord'
import { getToken } from '@utils'
import { wEditorDefaultConfig } from '@constant'
export default {
  components: { auditRecord },
  name: 'Live',
  data() {
    const validatePrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('定价不能为空'))
      } else if (!(Number(value) >= 0)) {
        callback(new Error('填写的数值须大于或等于0'))
      } else {
        callback()
      }
    }
    return {
      generalServiceType: [],
      id: '',
      uploadFile,
      uploadHeader: {
        Authorization: 'Bearer ' + getToken()
      },
      ruleForm: {
        name: '',
        region: '',
        useCoupon: '',
        goodsType: '',
        chargeMode: '线下支付',
        serveTarget: [],
        serveWay: [],
        desc: '',
        mainImgUrl: '',
        priceType: 1,
        price: '',
        serveArea: '',
        attachmentList: []
      },
      showImg: false,
      dialogVisible: false,
      exhibitImg: '',
      rules: {
        goodsName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }
        ],
        goodsType: [
          { required: true, message: '请选择商品类型', trigger: 'change' }
        ],
        priceType: [
          {
            required: true,
            message: '请至少选择一个价格设置',
            trigger: 'change'
          }
        ],
        price: [{ required: true, validator: validatePrice, trigger: 'blur' }],
        useCoupon: [
          {
            required: true,
            message: '请选择是否可用服务券',
            trigger: 'change'
          }
        ],
        chargeMode: [
          { required: true, message: '请选择收费模式', trigger: 'change' }
        ],
        mainImgUrl: [
          { required: true, message: '请上传主图', trigger: 'change' }
        ],
        desc: [{ required: true, message: '请输入商品简介', trigger: 'blur' }]
      },
      goodsTypeList: [],
      serveTargetList: [],
      serveWayList: [],
      fileList1: [], // 附件列表
      hideUpload: false, // 隐藏当前上传入口
      fileList: [],
      dialogImageUrl: '', // 预览图片路径
      goodsRecordList: [], // 审核记录
      disabled: false,
      generalServiceTypeOptions: [],
      serviceTypeOptions: [],
      organizationType: '' // 机构类型：1 机构，2 服务机构
    }
  },
  watch: {},
  computed: {},
  async created() {
    this.type = this.$route.query.type
    this.id = this.$route.query.id
    this.organizationType = this.$route.query.organizationType
    await this.getUserArea()
    await this.getAllDict()
    await this.getGoodsType()
    await this.getServiceTypeList()
    if (this.id) {
      this.getProductDetail()
    }
  },
  mounted() {
    this.wangEditor()
  },
  methods: {
    //
    changeCoupon(val) {
      this.generalServiceType = []
      this.ruleForm.goodsType = ''
      if (this.disabled) {
        // 服务券机构
        // 默认选中第一个
        if (this.generalServiceTypeOptions.length) {
          this.generalServiceType = [
            this.generalServiceTypeOptions[0].id,
            this.generalServiceTypeOptions[0].child[0].id
          ]
          this.ruleForm.goodsType =
            this.generalServiceTypeOptions[0].child[0].id
        }
      } else {
        if (this.serviceTypeOptions.length) {
          this.ruleForm.goodsType = this.serviceTypeOptions[0].id
        }
      }
    },
    // 普通机构选择商品类型
    changeGeneralService(val) {
      this.ruleForm.goodsType = val[1]
    },
    /** 创建富文本编辑器 */
    wangEditor() {
      let E = window.wangEditor
      this.editor = new E('#editor')
      this.editor.customConfig = {
        ...this.editor.customConfig,
        ...wEditorDefaultConfig
      }
      // console.log(this.editor.customConfig)
      // 配置菜单栏，设置不需要的菜单
      // this.editor.config.excludeMenus = [
      //   'video'
      // ]
      // 富文本编辑器内容校验
      let that = this
      this.editor.customConfig.onblur = function (html) {
        // 失去焦点时触发校验
        if (that.editor.txt.html() == '<p><br></p>') {
          that.$refs.ruleForm.validateField('desc')
        } else {
          that.$refs.ruleForm.clearValidate('desc')
        }
      }
      this.editor.create()
    },
    getUserArea() {
      getUserArea().then((res) => {
        if (res.data.code === '0000') {
          this.ruleForm.serveArea = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getAllDict() {
      return new Promise((resolve) => {
        allDictInfo().then((res) => {
          if (res.data.code === '0000') {
            this.serveTargetList = res.data.data.serveTargetList
            this.serveWayList = res.data.data.serveWayList
            resolve()
          }
        })
      })
    },
    getProductDetail() {
      entProductDetail({ id: this.id }).then((res) => {
        if (res.data.code === '0000') {
          const data = res.data.data
          const {
            brief,
            goodsName,
            goodsTypeId,
            priceType,
            price,
            useCoupon,
            chargeMode,
            serveArea,
            serveTargetIdStr,
            serveWayIdStr,
            goodsRecordList,
            attachmentList,
            img
          } = data
          this.goodsRecordList = goodsRecordList
          this.ruleForm = {
            desc: brief,
            goodsName,
            goodsType: goodsTypeId,
            priceType,
            price,
            useCoupon,
            chargeMode,
            serveArea,
            serveTarget: serveTargetIdStr
              ? serveTargetIdStr.split(',').map(Number)
              : [],
            serveWay: serveWayIdStr ? serveWayIdStr.split(',').map(Number) : [],
            attachmentList,
            mainImgUrl: img
          }
          this.fileList = [{ name: img.fileName, url: img.ossUrl }]
          this.hideUpload = this.fileList.length >= 1
          let fileNewList = []
          attachmentList.forEach((item, index) => {
            fileNewList.push({
              name: item.fileName,
              url: item.ossUrl
            })
          })
          this.fileList1 = fileNewList
          this.editor.txt.html(brief)
          // 处理商品类型 1 服务机构 2 普通机构
          if (this.ruleForm.useCoupon == 0) {
            this.generalServiceType = this.findParent(goodsTypeId)
          }
        }
      })
    },
    // 根据二级id找到子id
    findParent(id) {
      let list = []
      this.generalServiceTypeOptions.forEach((item) => {
        item.child.forEach((el) => {
          if (el.id == id) {
            list = [item.id, el.id]
          }
        })
      })
      return list
    },
    //
    getGoodsType() {
      return new Promise((resolve) => {
        getGoodsType().then((res) => {
          if (res.data.code === '0000') {
            this.ruleForm.useCoupon =
              res.data.data.roleText == '服务机构' ? 1 : 0
            this.disabled = res.data.data.roleText == '机构'
            resolve()
          }
        })
      })
    },
    getServiceTypeList() {
      return new Promise((resolve) => {
        getServiceTypeList().then((result) => {
          if (result.data.code === '0000') {
            // serviceTypeList generalServiceTypeList
            this.generalServiceTypeOptions =
              result.data.data.generalServiceTypeList || []
            this.serviceTypeOptions = result.data.data.serviceTypeList || []
            console.log(
              this.generalServiceTypeOptions,
              'this.generalServiceTypeOptions'
            )
            console.log(this.serviceTypeOptions, 'this.serviceTypeOptions')
            if (this.disabled) {
              // 默认选中第一个
              if (!this.id && this.generalServiceTypeOptions.length) {
                this.generalServiceType = [
                  this.generalServiceTypeOptions[0].id,
                  this.generalServiceTypeOptions[0].child[0].id
                ]
                this.ruleForm.goodsType =
                  this.generalServiceTypeOptions[0].child[0].id
              }
            } else {
              if (!this.id && this.serviceTypeOptions.length) {
                this.ruleForm.goodsType = this.serviceTypeOptions[0].id
              }
            }
            resolve()
          }
        })
      })
    },
    // 附件上传
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5
      const allowFileTypes = [
        'ppt',
        'pptx',
        'doc',
        'docx',
        'pdf',
        'xls',
        'xlsx'
      ]
      const fileName = file.name.split('.')
      let fileType = fileName[fileName.length - 1]
      const isFile = allowFileTypes.includes(fileType.toLowerCase())

      if (!isFile) {
        this.$message.error(
          '上传文件只能是 ppt、pptx、doc、docx、pdf、xls、xlsx 格式!'
        )
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 5MB!')
      }
      return isLt2M && isFile
    },
    handleExceed() {
      this.$message.warning('当前限制选择 5 个文件，已上传了5个文件')
    },
    docSuccess1(response, file, fileList) {
      if (response.code == '0000') {
        this.ruleForm.attachmentList.push(response.data)
      }
    },
    handleRemove1(file, fileList) {
      let index = null
      if (file.url) {
        // 删除返显的文件数据
        index = this.ruleForm.attachmentList.findIndex(
          (item) => item.ossUrl === file.url
        )
      } else {
        if (file.response && file.response.data.url) {
          // 删除新增的文件数据
          index = this.ruleForm.attachmentList.findIndex(
            (item) => item.ossUrl === file.response.data.url
          )
        }
      }
      this.ruleForm.attachmentList.splice(index, 1)
    },

    // 主图上传前校验
    beforePictureUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isLt5M) {
        this.$message.error('上传像图片大小不能超过 5MB!')
      }
      return isLt5M
    },
    // 点击预览上传的图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 主图上传成功
    docSuccess(response, file, fileList) {
      if (response.code == '0000') {
        this.ruleForm.mainImgUrl = response.data
        this.ruleForm.mainImgUrl.fileType = 1
        this.$refs.imageId.clearValidate()
      }
      // this.$refs.form.clearValidate('imageId')
    },
    // 主图移除文件
    handleRemove(file, fileList) {
      this.hideUpload = fileList.length >= 1
      this.ruleForm.mainImgUrl = ''
    },
    // 通过上传状态不同，隐藏上传的入口
    handleChangeImg(file, fileList) {
      this.hideUpload = fileList.length >= 1
    },

    // 取消
    handleCancel() {
      this.$confirm('当前填写信息不会保留，是否继续?')
        .then((_) => {
          this.$router.push({ name: 'productList' })
        })
        .catch((_) => { })
    },
    editSave() {
      this.$confirm('是否确定?', '保存成功后，商品需要手动上架并审核', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
        /* center: true, */
      })
        .then(() => {
          this.save()
          // this.$message({
          //   type: 'success',
          //   message: '保存成功!',
          // })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消保存'
          })
        })
    },
    // 保存商品
    save() {
      if (this.ruleForm.attachmentList.length) {
        this.ruleForm.attachmentList.map((item, index) => {
          item.fileType = 2
        })
      }

      this.ruleForm.desc =
        this.editor.txt.html() === '<p><br></p>' ? '' : this.editor.txt.html()
      const params = {
        goodsName: this.ruleForm.goodsName,
        goodsTypeId: this.ruleForm.goodsType,
        priceType: this.ruleForm.priceType,
        price: this.ruleForm.price,
        useCoupon: this.ruleForm.useCoupon,
        img: this.ruleForm.mainImgUrl,
        chargeMode: this.ruleForm.chargeMode,
        serveArea: this.ruleForm.serveArea,
        brief: this.ruleForm.desc,
        serveTargetIdStr:
          this.ruleForm.serveTarget.length > 0
            ? this.ruleForm.serveTarget.join(',')
            : '',
        serveWayIdStr:
          this.ruleForm.serveWay.length > 0
            ? this.ruleForm.serveWay.join(',')
            : '',
        attachmentList: this.ruleForm.attachmentList,
        organizationType: this.organizationType
      }
      if (this.type === 'edit') {
        Object.assign(params, { id: this.id })
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          addOrEditProduct(params).then((res) => {
            if (res.data.code === '0000') {
              this.$router.push({ name: 'productList' })
              this.$message({
                type: 'success',
                message: '保存成功'
              })
            } else {
              this.$message.error({
                type: 'error',
                message: res.data.msg
              })
            }
          })
        }
      })
    }
  }
}
</script>
<style>
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}
::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-track {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
}
.hide .el-upload--picture-card {
  display: none;
}
</style>
<style lang="scss" scoped>
.showImg {
  /deep/ .el-dialog__header {
    border-bottom: none !important;
  }
}
/deep/ .el-dialog__wrapper {
  .el-dialog__header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .el-dialog__body {
    // height: 400px;
    overflow: auto;
    padding: 30px 60px 20px;
    font-size: 16px;
    .el-textarea__inner {
      height: 100px;
    }
  }
  .el-upload--picture-card {
    width: 120px;
    height: 120px;
  }
  .el-upload-list__item {
    width: 120px;
    height: 120px;
  }
  .el-dialog__footer {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
}
.container {
  width: 100%;
  height: 100%;
  // overflow: auto;

  .unit {
    display: inline-block;
    margin: 0 5px;
  }
  .topContainer {
    width: 100%;
    height: calc(100% - 60px);
    display: flex;
    justify-content: space-between;
    & > .leftContent {
      width: 100%;
      height: calc(100% - 10px);
      &::-webkit-scrollbar-thumb {
        display: none;
      }

      overflow-y: scroll;
      background: white;
      > .header {
        background: white;
        padding-bottom: 20px;
        > .title {
          padding: 16px 21px;
          font-size: 16px;
          color: rgba(0, 0, 0, 0.85);
          font-weight: 600;
          border-bottom: 1px solid #eee;
        }
        & > .service {
          > div {
            width: 100%;
            display: flex;
            > div {
              > div {
                margin-bottom: 10px;
                > span {
                  margin-right: 10px;
                }
              }
            }
          }
        }
        & > .information {
          padding: 0 24px 16px;
          margin-top: 16px;
          display: flex;
          color: rgba(0, 0, 0, 0.85);
          font-size: 14px;
          > div {
            width: 400px;
            span {
              color: rgba(0, 0, 0, 0.5);
            }
          }
        }
      }
      .PriceBox {
        display: flex;
        width: 250px;
      }
      > .content {
        margin-top: 16px;
        background: white;
        > .title {
          padding: 16px 21px;
          font-size: 16px;
          color: rgba(0, 0, 0, 0.85);
          border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        }
        & > .information {
          padding: 0 24px 16px;
          margin-top: 16px;
          display: flex;
          color: rgba(0, 0, 0, 0.85);
          font-size: 14px;
          img {
            cursor: pointer;
            width: 200px;
            margin-right: 15px;
          }
          > div {
            width: 400px;
            span {
              color: rgba(0, 0, 0, 0.5);
            }
          }
        }
        > .text {
          padding: 0 21px;
          font-size: 14px;
          line-height: 25px;
          color: rgba(0, 0, 0, 0.5);
          > p {
            color: rgba(0, 0, 0, 0.85);
          }
        }
        > .ImgContent {
          padding: 0 21px 30px;
          display: flex;
          margin-top: 30px;
          > div {
            width: 167px;
            height: 200px;
            line-height: 200px;
            margin-right: 20px;
            > img {
              max-height: 200px;
              vertical-align: middle;
              width: inherit;
              cursor: pointer;
              border-radius: 3px;
            }
          }
        }
      }
      > .footer {
        margin-top: 16px;
        background: white;
        > .title {
          padding: 16px 21px;
          font-size: 16px;
          color: rgba(0, 0, 0, 0.85);
          border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        }
        > .block {
          width: 60%;
          margin-top: 30px;
        }
      }
      > .review {
        margin-top: 16px;
        padding: 24px 300px;
        background: white;
        /deep/ .el-textarea__inner {
          min-height: 150px !important;
        }
        .dialog-footer {
          display: flex;
          justify-content: center;
        }
      }
    }
  }

  .bottomBox {
    width: calc(100% - 46px);
    text-align: center;
    position: absolute;
    bottom: 20px;
    height: 60px;
    line-height: 60px;
    background: #fff;
    z-index: 9;
  }
}
.hide /deep/ .el-upload--picture-card {
  display: none;
}
</style>
